export const buildCurriculum = (sections = [], lessons = [], fallbackTitle) => {
  const known = new Set(sections.map(s => s.id));
  const loose = lessons.filter(l => !known.has(l.section_id));
  const groups = [
    ...(loose.length ? [{ id: '__loose__', title: fallbackTitle, lessons: loose }] : []),
    ...sections.map(s => ({ ...s, lessons: lessons.filter(l => l.section_id === s.id) })),
  ];
  const flat = [];
  groups.forEach((g, gi) => {
    g.lessons = g.lessons.map((l, li) => {
      const item = { ...l, num: groups.length > 1 || sections.length ? `${gi + 1}.${li + 1}` : `${li + 1}`, flatIndex: flat.length };
      flat.push(item);
      return item;
    });
  });
  return { groups, flat };
};

export const countLabel = (lang, n, [one, two, few, many], en) => {
  if (lang !== 'ar') return `${n} ${n === 1 ? en.replace(/s$/, '') : en}`;
  if (n === 1) return one;
  if (n === 2) return two;
  return `${n} ${n >= 3 && n <= 10 ? few : many}`;
};

export const lessonSecs = (l) => (l?.duration_sec || (l?.duration_min || 0) * 60);

export const fmtClock = (secs) => {
  if (!secs) return '';
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = String(secs % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
};

export const fmtDuration = (secs, lang) => {
  const total = Math.round((secs || 0) / 60);
  if (!total) return '';
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (lang === 'ar') return [h && `${h} س`, m && `${m} د`].filter(Boolean).join(' ');
  return [h && `${h}h`, m && `${m}m`].filter(Boolean).join(' ');
};
